module.exports = __webpack_public_path__ + "img/euro.82e95ee8.png";